export type { LemonTextAreaProps } from './LemonTextArea'
export { LemonTextArea } from './LemonTextArea'
export { LemonTextAreaMarkdown } from 'lib/lemon-ui/LemonTextArea/LemonTextAreaMarkdown'
